import { QueryClient } from '@tanstack/react-query';

// Module-wide React Query defaults per standards.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

// Query key helpers keep invalidation consistent across the module.
export const qk = {
  retailerList: (search) => ['sfa', 'list', 'retailers', search ?? ''],
  retailerDetail: (guid) => ['sfa', 'detail', 'retailer', guid],
  lookup: (name, ...args) => ['sfa', 'lookup', name, ...args],
};
